/* Component Dependencies */
var hotelDirectoryResultsTemplate = require('templates/hotelDirectoryResults.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelDirectoryResults',
  template: {
    'hotelDirectoryResults': hotelDirectoryResultsTemplate
  },

  events: {
    'click .js-region-toggle':'clickRegion'
  },
  bindEvents: function() {
    var _self = this;
    var defaultRegion = _self.$el.data("default-region");
    _self.displayCount();
    _self.pubsub.publish('SELECT_DIRECTORY_REGION_DETAIL', [defaultRegion]);
  },
  subscribe: {
    'SELECT_DIRECTORY_REGION_DETAIL': 'showRegion',
    'TOGGLE_HOTEL_DIRECTORY': 'toggleHotelDirectory'
  },
  displayCount: function(){
    var _self = this;
    _self.$el.find('.m-state-list').each(_self.countEachRegion);
  },
  countEachRegion: function(ndx,regionlist){
    var count = 0;
    $( regionlist )
      .find("[data-count]" )
      .each(function countEachSubRegion(ndx,regionItem){
        count += $( regionItem ).data().count;
      })
      .closest('.js-accordion').find('.js-region-count').text( "("+count+")" );
  },
  clickRegion: function(e){
    var _self = this;
    var target= $(e.currentTarget),
        targetAnchor = target.find('.l-toggle-list');
      if (targetAnchor.hasClass('is-open')) {
        targetAnchor.removeClass('is-open');

      } else {
        targetAnchor.addClass('is-open');
        this.pubsub.publish('SELECT_DIRECTORY_REGION', [targetAnchor.closest('.js-region-hdr').data().region ]);
      };
    _self.toggleHandler(target,e);
  },

  toggleHandler: function(toggleContainer,event) {
    if(event.target.tagName.toLowerCase() === 'a' && $(event.target).closest('.js-accordion-section').length) {
      return;
    }
    var toggleContainerOpenSibling = toggleContainer.siblings('.open');
    toggleContainer.toggleClass('open');
    if (toggleContainer.hasClass('open')) {
      toggleContainer.find('.js-accordion-section').slideDown('fast', function() {
        $(this).css('overflow', 'visible');
      });
      toggleContainer.find('.js-caption-label').html(toggleContainer.find('.l-toggle-list').data('label-expand'));
      if(toggleContainerOpenSibling.length){
        toggleContainerOpenSibling.find('.js-accordion-section').slideUp('fast');
        toggleContainerOpenSibling.find('.l-toggle-list').removeClass('is-open');
        toggleContainerOpenSibling.find('.js-caption-label').html(toggleContainerOpenSibling.find('.l-toggle-list').data('label-collapse'));
        toggleContainerOpenSibling.find(".js-caption-icon").toggleClass("t-icon-arrow-up").toggleClass("t-icon-arrow-down");
        toggleContainerOpenSibling.removeClass('open') ;
      }
    } 
    else if(!(toggleContainer.hasClass('open')) && ($(event.target).hasClass('js-accordion-header') || $(event.target).hasClass('js-caption-label') || $(event.target).hasClass('js-caption-icon'))){
      toggleContainer.find('.js-accordion-section').slideUp('fast');
      toggleContainer.find('.js-caption-label').html(toggleContainer.find('.l-toggle-list').data('label-collapse'));
    }
    else if(!(toggleContainer.hasClass('open'))){
      toggleContainer.find('.js-accordion-section').slideUp('fast');
      toggleContainer.find('.js-caption-label').html(toggleContainer.find('.l-toggle-list').data('label-collapse'));
    }
    toggleContainer.find(".js-caption-icon").toggleClass("t-icon-arrow-up").toggleClass("t-icon-arrow-down");
  },
  showRegion: function(region) {
    var _self = this;
    var el = _self.$el.find('[data-region="'+ region +'"] a')
    if (el.hasClass('is-open')) {
      el.removeClass('is-open');
    } else {
      el.addClass('is-open');
      setTimeout(function(){
         el[0].click();
      },100);
    }
  },
  toggleHotelDirectory: function _toggleHotelDirectory(isTileDisplayed){
    var _self=this;
    isTileDisplayed===true?_self.$el.removeClass('l-display-none').addClass('l-display-block'):_self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
});
